import { ActionStickerCard } from '@backrs_ui/common-ui';

import { Box, Grid, SxProps, Theme, Typography } from '@mui/material';

import { ActionStickerCardSection } from '../hooks/useGetHomePageSections';

type ActionStickerCardSectionProps = Readonly<{
  actionStickerSection: ActionStickerCardSection;
}>;

export const ActionStickerCardSectionDisplay = ({
  actionStickerSection,
}: ActionStickerCardSectionProps) => {
  return (
    <Grid container spacing={0} sx={sectionSx}>
      {/* LEFT COLUMN TITLE AND DESCRIPTION */}
      <Grid item md={12} lg={3} sx={titleDescContainerSx}>
        <Typography variant="text-md-bold">{actionStickerSection.title}</Typography>
        <Typography variant="text-sm-regular">{actionStickerSection.description}</Typography>
      </Grid>

      {/* RIGHT COLUMN STICKER CARDS */}
      <Grid item xs={12} lg={9} sx={actionStickerContainerSx}>
        <Box sx={stickersArraySx}>
          {actionStickerSection.actionStickerCards.map((sticker) => (
            <ActionStickerCard
              key={sticker.title}
              title={sticker.title}
              description={sticker.description}
              stickerUrl={sticker.stickerUrl}
              onClick={sticker.onClick}
            />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};

const sectionSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  paddingLeft: backrs.spacing['spacing-none'],
  marginLeft: backrs.spacing['spacing-none'],
});

const stickersArraySx: SxProps<Theme> = ({ backrs }) => ({
  display: 'grid',
  gridTemplateColumns: {
    xs: 'repeat(1, minmax(100%, 1fr))',
    md: 'repeat(2, 1fr)',
  },
  rowGap: 2,
  columnGap: 2,
  width: 'fit-content',
  mt: {
    xs: backrs.spacing['spacing-2xl'],
    lg: backrs.spacing['spacing-none'],
  },
});

const titleDescContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-lg'],
  paddingLeft: `${backrs.spacing['spacing-none']} !important`,
  paddingRight: `${backrs.spacing['spacing-7xl']} !important`,
});

const actionStickerContainerSx: SxProps<Theme> = ({ backrs }) => ({
  paddingLeft: `${backrs.spacing['spacing-none']} !important`,
});
